let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lTvyt")).then(() => parcelRequire('aYYK8'));